export default {"src":"/uk/_next/static/media/spot-thumb-up.fcbd28b7.svg","height":50,"width":47,"blurWidth":0,"blurHeight":0};